/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PreseasonGameSummaryResponseDto } from '../models/PreseasonGameSummaryResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PreseasonGameSummaryControllerService {
    /**
     * @param teamId
     * @returns PreseasonGameSummaryResponseDto OK
     * @throws ApiError
     */
    public static getPreseasonGameSummary(
        teamId: number,
    ): CancelablePromise<PreseasonGameSummaryResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-game-summary/{teamId}',
            path: {
                'teamId': teamId,
            },
        });
    }
}
